var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppointmentview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.34375 9.07031H20.6637",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5916 5.71876C18.2025 5.71876 18.7885 5.96076 19.2215 6.39181C19.6544 6.82286 19.8989 7.40785 19.9016 8.01876V18.2088C19.8989 18.8206 19.6547 19.4066 19.2221 19.8393C18.7894 20.2719 18.2034 20.5161 17.5916 20.5188H7.41156C6.79972 20.5161 6.21369 20.2719 5.78105 19.8393C5.34841 19.4066 5.10419 18.8206 5.10156 18.2088V8.01876C5.10421 7.40785 5.34875 6.82286 5.78167 6.39181C6.21459 5.96076 6.80064 5.71876 7.41156 5.71876H17.5916ZM17.5916 4.21876H7.41156C6.9117 4.21745 6.41648 4.31477 5.95429 4.50515C5.4921 4.69552 5.07201 4.97522 4.71809 5.32822C4.36416 5.68121 4.08336 6.10056 3.89177 6.56225C3.70018 7.02394 3.60156 7.5189 3.60156 8.01876V18.2088C3.60156 19.2192 4.00297 20.1883 4.71748 20.9028C5.432 21.6174 6.40109 22.0188 7.41156 22.0188H17.5916C18.602 22.0188 19.5711 21.6174 20.2856 20.9028C21.0002 20.1883 21.4016 19.2192 21.4016 18.2088V8.01876C21.4016 7.5189 21.3029 7.02394 21.1114 6.56225C20.9198 6.10056 20.639 5.68121 20.285 5.32822C19.9311 4.97522 19.511 4.69552 19.0488 4.50515C18.5866 4.31477 18.0914 4.21745 17.5916 4.21876V4.21876Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46094 2.99219V4.92219",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5391 2.99219V4.92219",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 19C15.2091 19 17 17.2091 17 15C17 12.7909 15.2091 11 13 11C10.7909 11 9 12.7909 9 15C9 17.2091 10.7909 19 13 19Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5709 13.6605C13.5737 13.4753 13.6211 13.2936 13.709 13.1306C13.4823 13.045 13.2422 13.0008 13 13C12.6044 13 12.2178 13.1173 11.8889 13.3371C11.56 13.5568 11.3036 13.8692 11.1522 14.2346C11.0009 14.6001 10.9613 15.0022 11.0384 15.3902C11.1156 15.7781 11.3061 16.1345 11.5858 16.4142C11.8655 16.6939 12.2219 16.8844 12.6098 16.9616C12.9978 17.0387 13.3999 16.9991 13.7654 16.8478C14.1308 16.6964 14.4432 16.44 14.6629 16.1111C14.8827 15.7822 15 15.3956 15 15C14.9995 14.9114 14.9933 14.8229 14.9813 14.7351C14.8869 14.7635 14.7889 14.7786 14.6903 14.7799C14.3934 14.7799 14.1087 14.6619 13.8988 14.452C13.6888 14.242 13.5709 13.9573 13.5709 13.6605Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentview);
export default __webpack_public_path__ + "static/media/appointmentview.fac71d05a8eda288b25552ee91178950.svg";
export { ForwardRef as ReactComponent };